import { useQuery } from "@tanstack/react-query";
import { customAxios } from "lib/axios";

export interface OrgUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  position?: string;
  role?: string;
  department?: {
    _id: string;
    name: string;
  };
}

export interface AllOrgUsersResponse {
  success: boolean;
  data: OrgUser[];
}

const fetchAllOrgUsers = async (): Promise<AllOrgUsersResponse> => {
  const { data } = await customAxios.get<AllOrgUsersResponse>(
    "/organizations/search/user",
    {
      params: {
        query: "", // Empty query to get all users
        limit: 1000, // High limit to get all users
      },
    }
  );
  return data;
};

export const useGetAllOrgUsers = () =>
  useQuery<AllOrgUsersResponse>(["org-users"], fetchAllOrgUsers, {
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
  });
